export var AppSection;
(function (AppSection) {
    AppSection["Retail"] = "Retail";
    AppSection["RetailIntegral"] = "RetailIntegral";
    AppSection["Enterprise"] = "Enterprise";
    AppSection["EnterpriseIntegral"] = "EnterpriseIntegral";
    AppSection["SelfEmployed"] = "SelfEmployed";
    AppSection["Attractiveness"] = "Attractiveness";
})(AppSection || (AppSection = {}));
